import { useEffect, useRef, useState, RefObject } from 'react';

const CLOSING_DELAY = 50;

export const useToggleSubmenu = ({
  buttonRef, containerRef
}: {
  buttonRef: RefObject<HTMLElement>, containerRef: RefObject<HTMLElement>
}) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const button = buttonRef.current;
  const container = containerRef.current;
  const [isOpen, setOpen] = useState(false);

  const handleMouseMove = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (button?.contains(target) || container?.contains(target)) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    } else {
      if (!timerRef.current) timerRef.current = setTimeout(() => handleCloseTemplates(), CLOSING_DELAY);
    }
  };

  const handleMouseEnter = () => {
    setOpen(true);
    document?.addEventListener('mousemove', handleMouseMove);
  };

  const handleCloseTemplates = () => {
    setOpen(false);
    document?.removeEventListener('mousemove', handleMouseMove);
  };

  useEffect(() => {
    button?.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      button?.removeEventListener('mouseEnter', handleMouseEnter);
      document?.removeEventListener('mousemove', handleMouseMove);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [button]);

  return {
    open: isOpen,
    close: () => setOpen(false)
  };
};
